import moment from "moment";
import { NeedModel } from "./need.model";
import { FileModel } from "./file.model";
import { RequirementModel } from "./requirement.model";
import { GroupModel } from "./group.model";
import { ProjectRequestModel } from "./project-request.model";
import { BudgetModel } from "./budget.model";
import { ContractModel } from "./contract.model";
import { ProposalModel } from "./proposal.model";
import { User } from "src/app/core/models/auth.models";
import { ProjectModel } from "../../projects/models/project.model";
import { AuthenticationService } from "src/app/core/service/auth.service";

export enum Status {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Budget = 'BUDGET',
  Proposal = 'PROPOSAL',
  Contract = 'CONTRACT',
  Approved = 'APPROVED',
  Revision = 'REVISION',
  Rejected = 'REJECTED',
  Pending = 'PENDING'
}
export class RequestVersionModel {
  public id: number;

  public description: string;
  public startDate: Date;
  public estimatedFinalDate: Date | null;
  public proposalFinalDate: Date | null;
  public availableBudget: number | null;
  public targetUsers: string;
  public currency: string | null;

  public version: string;
  public status: Status;

  public authorId: number | null;
  public projectId: number | null;
  public projectRequestId: number | null;

  public author: User | null;
  public project: ProjectModel | null;
  public projectRequest: ProjectRequestModel | null

  public needs: NeedModel[];
  public uploadedFiles: FileModel[];
  public requirementGroups: GroupModel[];
  public requirements: RequirementModel[];

  public budgets: BudgetModel[];
  public proposals: ProposalModel[];
  public contracts: ContractModel[];

  public createdAt: Date;
  public updatedAt: Date;

  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : '#new' + moment().valueOf();

    this.description = $obj && $obj.description ? $obj.description : '';
    this.startDate = $obj && $obj.startDate ? new Date($obj.startDate) : new Date();
    this.estimatedFinalDate = $obj && $obj.estimatedFinalDate ? new Date($obj.estimatedFinalDate) : null;
   
    this.proposalFinalDate = $obj && $obj.proposalFinalDate ? new Date($obj.proposalFinalDate) : null;
    this.availableBudget = $obj && $obj.availableBudget ? $obj.availableBudget : 0;
    this.targetUsers = $obj && $obj.targetUsers ? $obj.targetUsers : '';
    this.currency = $obj && $obj.currency ? $obj.currency : null

    this.version = $obj && $obj.version ? $obj.version : 1;
    this.status = $obj && $obj.status ? $obj.status : Status.Draft;

    this.authorId = $obj && $obj.authorId ? $obj.authorId : $obj && $obj.author ? $obj.author.id : null;
    this.projectId = $obj && $obj.projectId ? $obj.projectId : $obj && $obj.project ? $obj.project.id : null;
    this.projectRequestId = $obj && $obj.projectRequestId ? $obj.projectRequestId : $obj && $obj.projectRequest ? $obj.projectRequest.id : null;

    this.author = $obj && $obj.author ? new User($obj.author) : null;
    this.project = $obj && $obj.project ? new ProjectModel($obj.project) : null;
    this.projectRequest = $obj && $obj.projectRequest ? new ProjectRequestModel($obj.projectRequest) : null;

    this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : [];
    this.needs = $obj && $obj.needs ? $obj.needs : [];
    this.requirementGroups = $obj && $obj.requirementGroups ? $obj.requirementGroups : [];
    this.requirements = $obj && $obj.requirements ? $obj.requirements : [];

    this.budgets = $obj && $obj.budgets ? $obj.budgets : [];
    this.proposals = $obj && $obj.proposals ? $obj.proposals : [];
    this.contracts = $obj && $obj.contracts ? $obj.contracts : [];

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
  }

  get canEditRequirements(): boolean { return this.status === Status.Submitted ? true : false; }
  get canEditGeneral(): boolean { return this.status === Status.Draft ? true : false; }
  get isDraft(): boolean { return this.status === Status.Draft ? true : false; }
  get isSubmitted(): boolean { return this.status === Status.Submitted ? true : false; }
  get isBudget(): boolean { return this.status === Status.Budget ? true : false; }
  get isProposal(): boolean { return this.status === Status.Proposal ? true : false; }
  get isContract(): boolean { return this.status === Status.Contract ? true : false; }
  get isApproved(): boolean { return this.status === Status.Approved ? true : false; }
  get canContract(): boolean { return this.status !== Status.Approved ? true : false; }


  getDropdownVersionByType(type: string, currentUser: User | null): { list: BudgetModel[], options: any[] } {
    const dropdown: { list: any[], options: any[] } = { list: [], options: [] };
    if (type === 'Budget') {
      dropdown.list = currentUser?.isPartner ? this.budgets.filter((f: any) => f.status !== Status.Draft) : this.budgets;
    } else if (type === 'Budget_Proposal') {
      dropdown.list = this.budgets.filter((f: any) => f.status === Status.Approved);
    } else if (type === 'Proposal') {
      dropdown.list = currentUser?.isCustomer ? this.proposals.filter((f: any) => f.status !== Status.Draft) : this.proposals;
    } else {
      dropdown.list = currentUser?.isCustomer ? this.contracts.filter((f: any) => f.status !== Status.Draft) : this.contracts;
    }

    if (dropdown.list.length > 0) {
      dropdown.list.forEach((f: any) => {
        const label = type === 'Contract' ? `V${f.version} ${moment(f.startDate).format('YYYY-MM-DD')} (${f.status})` : `V${f.version} ${moment(f.date).format('YYYY-MM-DD')} (${f.status})`;
        dropdown.options.push({ label: label, value: f.id });
      });
      dropdown.options = dropdown.options.sort((a, b) => a.value < b.value ? -1 : 1);
    }
    return dropdown;
  }

  disableTab(tab: number, user: User | null) {
    let res;
    switch (tab) {
      case 1: {
        res = !user?.isCustomerOrPartner && this.isDraft ? true : false;
        break;
      }
      case 2: {
        res = !user?.isCustomer && this.isDraft || this.isSubmitted ? true : false;
        break;
      }
      case 3: {
        res = this.isDraft || this.isSubmitted || this.isBudget ? true : false;
        break;
      }
      case 4: {
        res = this.isDraft || this.isSubmitted || this.isBudget || this.isProposal ? true : false;
        break;
      }
      default: {
        res = false;
        break;
      }
    }

    return res;
  }

  setByForm(form: any, rightForm?: any) {
    this.description = form.description;
    this.targetUsers = form.targetUsers;
    this.estimatedFinalDate = new Date(form.projectDueDate);
    this.proposalFinalDate = new Date(form.proposalDueDate);
    this.availableBudget = form.availableBudget !== '' ? parseInt(form.availableBudget) : null;
    this.currency = form.currency;

    if (rightForm && rightForm.status !== '') this.status = rightForm.status;
    if (rightForm && rightForm.version !== '') this.version = rightForm.version.toString();

    return this;
  }

  toAPI() {
    if (this.needs) {
      return {
        description: this.description,
        targetUsers: this.targetUsers,
        availableBudget: this.availableBudget,
        startDate: this.startDate.toISOString(),
        estimatedFinalDate: this.estimatedFinalDate!.toISOString(),
        proposalFinalDate: this.proposalFinalDate!.toISOString(),
        currency: this.currency,
        needs: this.needs
      };
    }
    return {
      description: this.description,
      targetUsers: this.targetUsers,
      availableBudget: this.availableBudget,
      startDate: this.startDate.toISOString(),
      estimatedFinalDate: this.estimatedFinalDate!.toISOString(),
      proposalFinalDate: this.proposalFinalDate!.toISOString(),
      currency: this.currency
    };
  }
}
